export default __webpack_public_path__ + "static/media/minikarat.e98e0d2c.gif";